import { IFaqContentItems } from '@common/models/CMS/FAQ';
import { FC } from 'react';
import ParagraphWidget from "@components/Widgets/ParagraphWidget";
import Accordion from '@components/general/Accordion';

export interface IFaqItem {
    data: IFaqContentItems;
    expandAccordion?: boolean;
}

const FaqItem: FC<IFaqItem> = ({ data, expandAccordion }) => {

    return (
        <section className='faq-item'>
            <Accordion title={data?.displayText} expand={expandAccordion}>
                <ParagraphWidget dataSource={{ text: data?.answer }} />
            </Accordion>
        </section>
    );
}

export default FaqItem 